import React from 'react';
import CoverImageSix from './CoverImageSix';
import ReservationForm from './ReservationForm';
import Footer from './Footer';

const Contact = () => {
    return (
        <div>

            <CoverImageSix/>
            <ReservationForm/>
            <Footer/>
        </div>
    );
};

export default Contact;